import { FormExtractorService } from "../../../shared/services/form-extractor.service";
import { LogService } from "../../../shared/services/log.service";
import { Validator } from "../../../shared/services/validator";
import { CTRL_NAME_EXTRACTOR } from "../ctrl.name.extractor";

export class CTRL_526 implements Validator {

    public static id = 'CTRL_526';
    private message = 'error.ctr_526';


    public LOG: LogService = new LogService(CTRL_526);
    public formExtractorService: FormExtractorService = new FormExtractorService();

    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_526.id + '_');

        if (rgs.length > 0) {
            for (var rg of rgs) {
                const ctrl = form.controls[rg];
                let numLot = rg.substr(rg.length - 1);
                const valeurBasseNameWithStepId = map.get(ctrl.value.rgCtrls.valeurBasse.replace('INDEX_525_1', numLot));
                const valeurHauteNameWithStepId = map.get(ctrl.value.rgCtrls.valeurHaute.replace('INDEX_525_1', numLot));
                const valeurBasseCtrl = form.controls[valeurBasseNameWithStepId];
                const valeurHauteCtrl = form.controls[valeurHauteNameWithStepId];

                if (this.isNotEmptyOrNullOrUndefined (valeurBasseCtrl.value) &&
                    this.isNotEmptyOrNullOrUndefined (valeurHauteCtrl.value) &&
                    valeurBasseCtrl.value >= valeurHauteCtrl.value) {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                } else {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                }
            }
        }
    }
    isNotEmptyOrNullOrUndefined(value): boolean {
		return (value !== undefined && value !== null && value !== '');
	}
}
